import emojiConf from './emoji';

// 格式化评论表情
export const formatCommentEmoji = comment => {
    const reg = /\[([^[\]]+)]/g;

    const text = comment.replace(reg, (match, p1) => {
        const emoji = emojiConf.find(item => item.code === `[${p1}]`);

        if (emoji) {
            return `<img data-type="emoji" src="${`https://x0.ifengimg.com/fe/ifengNews/emoji2/2021-12-01/${
                emoji.url
            }`}" alt="${p1}" />`;
        }

        return match;
    });

    return text;
};
